import { forwardRef } from 'react'
import classNames from 'classnames'
import { useConfig } from '../ConfigProvider'
import RingIndicator from './RingIndicator'

const Spinner = forwardRef((props, ref) => {

    const {
        className,
        color,
        enableTheme = true,
        indicator: Component = RingIndicator,
        isSpining = true,
        size = 20,
        style,
        ...rest
    } = props

    const { themeColor, primaryColorLevel } = useConfig()

    const spinnerColor = color || (enableTheme && `${themeColor}-${primaryColorLevel}`)

    const spinnerStyle = {
        height: size,
        width: size,
        ...style
    }

    const spinnerClass = classNames(
        isSpining && (Component === RingIndicator ? 'animate-spinner-rotate' : 'animate-spin'),
        spinnerColor && `text-${spinnerColor}`,
        className
    )

    return (
        <Component ref={ref} style={spinnerStyle} className={spinnerClass} {...rest} />
    )
})

export default Spinner
